type SpinnerProps = {
  text: string;
};

export default function Spinner(
  { text }: SpinnerProps = { text: "Loading..." },
) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <span className="loading loading-spinner loading-lg text-primary"></span>
        <p className="mt-4 text-sm opacity-70">{text}</p>
      </div>
    </div>
  );
}
